module.exports = __webpack_public_path__ + "img/c8d1a05.png";